<div class="flex flex-row my-12 gap-4 justify-center">
  <div>
    <i [class]="iconClass"></i>
  </div>

  <div class="flex flex-col">
    <h1>{{ title }}</h1>
    <div>{{ message }}</div>
  </div>
</div>